/**
 * Created by sxp23 on 2/1/2018.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './../app-routing.module';
import { CommonService} from './../common.service'
import { HeaderComponent } from './header.component'


@NgModule({
  declarations: [HeaderComponent],
  imports: [BrowserModule,CommonModule, AppRoutingModule, FormsModule],
  providers: [CommonService],
  exports: [ HeaderComponent ],
  bootstrap: [ HeaderComponent ],
})

export class HeaderModule { }
